import { render, staticRenderFns } from "./HistoryNoResults.vue?vue&type=template&id=6debdb06"
import script from "./HistoryNoResults.vue?vue&type=script&lang=ts"
export * from "./HistoryNoResults.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports